<template>
  <div>
    <el-tabs class="grid-content content-margin">
      <el-tab-pane :label="$t(`message.${this.title}`)">
        <table>
          <!-- 头部按钮 -->
          <tr>
            <OrgButtonArea
              @onEdit="onEdit"
              @onSave="onSave"
              @onRefresh="onRefresh"
              @onCancel="onCancel"
              @onBack="onBack"
              @onAdd="onAdd"
              ref="orgButton"
              :isAddMode="this.isAddMode"
              :isEditMode="this.isEditMode"
            ></OrgButtonArea>
            <el-divider></el-divider>
          </tr>

          <tr>
            <div
              :style="{
                height: this.clientHeight + 'px',
                overflow: 'auto',
              }"
            >
              <!-- <table class="simpleRow" v-show="isAddMode || isEditMode" >
                <tr>
                  <td>
                    <el-link :underline="false">
                      <el-button size="medium" round @click="isShowAccountStore = true">
                        <i class="iconfont">&#xe667;</i>
                        选择员工
                      </el-button>
                    </el-link>
                  </td>
                </tr>
              </table> -->

              <table class="simpleRow" >
                <tr>
                  <td width='10%' align='left'>
                    <span class="simpleLabel">ID:</span>
                  </td>
                  <td width='35%'>
                    <el-input
                      clearable
                      v-model="serverData.backaccountid"
                      size="small"
                      :disabled="true"
                    />
                  </td>
                  <td width='5%'></td>
                  <td width='10%' align='left'>
                    <span class="simpleLabel">{{$t('message.姓名')}}</span>
                  </td>
                  <td width='40%'>
                    <el-input
                      clearable
                      v-model="serverData.name"
                      size="small"
                      :disabled="true"
                    />
                  </td>
                </tr>
              </table>

              <table class="simpleRow" >
                <tr>
                  <td width='10%' align='left'>
                    <span class="simpleLabel">{{$t('message.手机')}}</span>
                  </td>
                  <td width='35%'>
                    <el-input
                      clearable
                      v-model="serverData.mobile"
                      size="small"
                      :disabled="true"
                    />
                  </td>
                  <td width='5%'></td>
                  <td width='10%' align='left'>
                    <span class="simpleLabel">{{$t('message.性别')}}</span>
                  </td>
                  <td width='40%'>
                    <el-input
                      clearable
                      :value="getAccountGenderName(serverData.gender)"
                      size="small"
                      :disabled="true"
                    >
                    </el-input>
                  </td>
                </tr>
              </table>

              <table class="simpleRow" >
                <tr>
                  <td width='10%' align='left'>
                    <span class="simpleLabel">{{$t('message.工作名称')}}</span>
                  </td>
                  <td width='35%'>
                    <el-input
                      clearable
                      v-model="serverData.workname"
                      size="small"
                      :disabled="!isEditMode && !isAddMode"
                    />
                  </td>
                  <td width='5%'></td>
                  <td width='10%' align='left'>
                    <span class="simpleLabel">{{$t('message.联系方式')}}</span>
                  </td>
                  <td width='40%'>
                    <el-input
                      clearable
                      v-model="serverData.contact"
                      size="small"
                      :disabled="!isEditMode && !isAddMode"
                    />
                  </td>
                </tr>
              </table>

              <table class="simpleRow" >
                <tr>
                  <td width='10%' align='left'>
                    <span class="simpleLabel">{{$t('message.状态')}}</span>
                  </td>
                  <td >
                    <el-radio-group
                      v-model="serverData.estate"
                      :disabled="!isEditMode && !isAddMode"
                    >
                      <el-radio :label="0">{{$t('message.普通')}}</el-radio>
                      <el-radio :label="1">{{$t('message.禁用')}}</el-radio>
                      <el-radio :label="2">{{$t('message.删除')}}</el-radio>
                    </el-radio-group>
                  </td>
                </tr>
              </table>

              <table class="simpleRow" >
                <tr>
                  <td width='10%'>
                    <span class="simpleLabel">{{$t('message.备注')}}</span>
                  </td>
                   <td width='90%'>
                    <el-input
                      type="textarea"
                      :rows="3"
                      :placeholder="$t('message.请输入内容')"
                      v-model="serverData.comment"
                      :disabled="!isEditMode && !isAddMode"
                    >
                    </el-input>
                  </td>
                </tr>
              </table>

              <el-divider></el-divider>
              <div :style="{ 'margin-top': '20px' }">
                <el-table
                  :data="serverData.jobs"
                  style="width: 100%"
                  height="150"
                >
                  <el-table-column
                    sortable
                    fixed
                    prop="departmentid"
                    :label="$t('message.部门ID')"
                    min-width="100"
                  >
                  </el-table-column>

                  <el-table-column
                    sortable
                    fixed
                    prop="departmentname"
                    :label="$t('message.部门名称')"
                    min-width="150"
                  >
                  </el-table-column>

                  <el-table-column
                    sortable
                    prop="jobid"
                    :label="$t('message.岗位ID')"
                    min-width="100"
                  >
                  </el-table-column>

                  <el-table-column
                    sortable
                    prop="jobname"
                    :label="$t('message.岗位名称')"
                    min-width="150"
                  >
                  </el-table-column>

                  <!-- <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                      <el-button
                        @click.native.prevent="deleteRow(scope.$index)"
                        type="text"
                        size="small"
                        v-show="isEditMode"
                      >
                        移除
                      </el-button>
                    </template>
                  </el-table-column> -->
                </el-table>
              </div>

              <!-- 编辑修改信息 -->
              <div v-show="!isAddMode">
                <el-divider></el-divider>
                <EditInfo
                  v-show="!isAddMode"
                  ref="eeei"
                  :createdate="serverData.createdate"
                  :editdate="serverData.editdate"
                ></EditInfo>
              </div>
            </div>
          </tr>
        </table>
      </el-tab-pane>
    </el-tabs>

    <shade v-if="isShowAccountStore > 0">
      <orginstore
        @onCancelChoseAccount="onCancelChoseAccount"
        @onSelectAccount="onSelectAccount"
      ></orginstore>
    </shade>

    <!-- <shade v-show="isShowAccountStore > 0">
        <AccountStore
          v-bind:ismulti="false"
          v-bind:excludeList="excludeList"
          :key="timer"
          @onClick="onStoreClick"
        ></AccountStore>
      </shade> -->
  </div>
</template>

<script>
import EditInfo from "@/components/Organization/EditInfo.vue";
import OrgButtonArea from "@/components/Organization/OrgButtonArea.vue";
import shade from "@/components/shade/shade";
import orginstore from "@/components/Organization/orginstore.vue";
import commonUtil from "@/utils/commonUtil";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";

export default {
  name: "employeditstore",
  components: {
    EditInfo,
    OrgButtonArea,
    shade,
    orginstore,
  },

  props: {
    clientHeight: 0,
    isAddMode: false,
    employeeid: null,
  },

  data() {
    return {
      isEditMode: false,
      isShowAccountStore: false,
      accountData: {},
      title: "员工信息",

      serverData: {
        appid: 188,
        estate: "0",
      },
      tableData: [],
    };
  },

  methods: {
    onEdit() {
      this.isEditMode = true;
    },

    onCancel() {
      this.isEditMode = false;
    },

    onRefresh() {
      if (this.employeeid == null) {
        return;
      }

      // this.$http
      //   .get("/manage/organization/employee/getinfo", {
      //     params: {
      //       appid: this.serverData.appid,
      //       userid: this.employeeid,
      //     },
      //   })
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       this.serverData = doc.data.data;
      //       this.$refs.eeei.getServerData(doc.data.exData.datas);
      //     }
      //   });
    
    },

    onSave() {
      if (this.serverData.workname.length == 0) {
        this.$alert({
          type: "error",
          message: this.$t('message.工作名称不能为空'),
        });
        return;
      }

      this.serverData.state = this.serverData.estate;
      rejecthttp(true,'post',"/manage/organization/employee/updateemployee",this.serverData,this,(doc) => {
            changeflagCLOSED(doc,1,this)
            if(doc.data.Code == "MSGKEY_OK"){
            this.onBack();
            }
            })
      // this.$http
      //   .post("/manage/organization/employee/updateemployee", this.serverData)
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       this.$message({
      //         type: "success",
      //         message: "保存成功",
      //       });
      //       this.onBack();
      //     }
      //   });
    },

    onBack() {
      this.$emit("onBack");
    },

    onAdd() {
      if (this.serverData.workname == 0) {
        this.$message({
          type: "error",
          message: thsi.$t('message.员工名称不能为空'),
        });
        return;
      }

      this.serverData.state = this.serverData.estate;
      rejecthttp(true,'post',"/manage/organization/employee/addemployee",this.serverData,this,(doc) => {
            changeflagCLOSED(doc,1,this)
            if(doc.data.Code == "MSGKEY_OK"){
            this.onBack();
            }
            })
      // this.$http
      //   .post("/manage/organization/employee/addemployee", this.serverData)
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       this.$message({
      //         type: "success",
      //         message: doc.data.Message,
      //       });
      //       this.onBack();
      //     }
      //   });
    },

    onCancelChoseAccount() {
      this.isShowAccountStore = false;
      this.onBack();
    },

    onSelectAccount(data) {
      
      this.isShowAccountStore = false;
      if (data == null) {
        this.onBack();
      } else {
        this.serverData.backaccountid = data.backaccountid;
        this.serverData.name = data.name;
        this.serverData.gender = data.gender;
        this.serverData.mobile = data.mobile;
      }
    },

    getAccountGenderName(gender) {
      return commonUtil.getGenderName(gender);
    },
  },

  mounted: function () {},

  watch: {
    clientHeight: {
      handler(val, oldVal) {},
      deep: true,
      immediate: true,
    },
    isAddMode: {
      handler(val, oldVal) {
        if (val == true) {
          this.title = "添加员工";
          this.isShowAccountStore = true;
          for (let key in this.serverData) {
            if (key != "appid" && key != "estate") {
              this.serverData[key] = null;
            }
          }
        } else {
          this.title = "员工信息";
        }
      },
      deep: true,
      immediate: true,
    },
    employeeid: {
      handler(val, oldVal) {
        this.onRefresh();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Organization/EmployeeEditstore.vue